export default {
  addAccount: 'アカウント追加',
  name: '名前',
  namePlaceholder: '名前を入力してください',
  email: 'メールアドレス',
  emailPlaceholder: 'メールアドレスを入力してください',
  search: '検索',
  phone: '電話番号',
  phonePlaceholder: '電話番号を入力してください',
  role: '役割',
  rolePlaceholder: '役割を選択してください',
  status: 'ステータス',
  createTime: '作成日時',
  actions: '操作',
  edit: '編集',
  disable: '無効化',
  enable: '有効化',
  delete: '削除',
  active: '有効',
  disabled: '無効',
  operation: '運営',
  addAccountTitle: 'アカウント追加',
  editAccountTitle: 'アカウント編集',
  loginEmail: 'ログインメールアドレスを入力してください',
  selectCountry: '国/地域を選択してください',
  password: 'パスワード',
  passwordPlaceholder: 'パスワードを入力してください',
  selectRole: '役割を選択してください',
  cancel: 'キャンセル',
  confirm: '確認',
  resetPassword: 'パスワードリセット',
  newPassword: '新しいパスワード',
  newPasswordPlaceholder: '新しいパスワードを入力してください',
  yes: 'はい',
  no: 'いいえ',
  confirmDelete: 'このアカウントを削除してもよろしいですか？',
};
